import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn cn() utility — composes clsx + tailwind-merge so that
 * `cn("p-2", condition && "p-4")` does NOT produce duplicate
 * `padding` utilities. Required by every shadcn primitive.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
